import * as api from "../../api";
import { buildAlertWithLocalizedMessages } from "../";
import { jsError } from "../../common/utils";

// new keys must be added to fi/esalary/common/domain/organizationdata/IntegrationKeys.java

export const getIntegrations = (businessId) => async (dispatch) => {
  try {
    const resp = await api.organizationIntegrationsGet(businessId);
    const activeIntegrations = resp?.data || {};
    
    // API returns integrations grouped by category e.g. { PAYROLL: { settingsEsalary: true } }
    // Flatten to a single map so existing consumers can read activeIntegrations.tokenXYZ directly
    const flattenedIntegrations = Object.values(activeIntegrations).reduce((acc, entries) => ({ ...acc, ...entries }), {});
    dispatch(operationSucceeded(flattenedIntegrations));
  } catch (e) {
    if (e.response?.status === 404) {
      dispatch(operationSucceeded({ credentialsFinagoTime: false }));
    } else {
      jsError(e);
      dispatch(operationFail());
      dispatch(
        buildAlertWithLocalizedMessages(
          "ERROR",
          "FetchIntegrationsAlertTitle",
          "Virhe liittymien noutamisessa",
          e.response?.data?.localizedMessages || null
        )
      );
    }
  }
};

const operationSucceeded = data => ({
  type: "GET_INTEGRATIONS_SUCCEEDED",
  payload: { activeIntegrations: data },
});

const operationFail = () => ({
  type: "GET_INTEGRATIONS_FAIL",
});


export const setIntegration = (key, bool) => ({
  type: "SET_INTEGRATION_SUCCEEDED",
  payload: { activeIntegrations: {[key]: bool} },
});
